// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Ensure dataLayer exists for Google Tag Manager
window.dataLayer = window.dataLayer || [];
// push an initial event so GTM has a start timestamp (head script also does this)
window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);